import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import membercard from "../../assets/images/Svg/Membershipcard.svg";
import family from "../../assets/Icons/membership/familyIcon.png";
import twin from "../../assets/Icons/membership/twinIcon.png";
import single from "../../assets/Icons/membership/singleIcon.png";
import member from "../../assets/membership/membership.svg";
import Empty from "../../assets/membership/Emptydata.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MemberShipService from "../../Services/MemberShipService";
import { Flex, message, Modal, Spin } from "antd";
import Tickicon from "../../assets/membership/tick.svg";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { CiMedicalCase } from "react-icons/ci";
import dayjs from "dayjs";
import { fetchMembershipPlans } from "../../Redux/actions/membershipActions";
import { AddtoCart, getCartDetails } from "../../Redux/actions/cartActions";
import PatientService from "../../Services/PatientService";
import { getCurrentTime } from "../../Shared/CartHelper";

function Membership() {
  const patientData = useSelector((state) => state.auth.patientData);
  const [planDetails, setPlanDetails] = useState(null);
  const [planDetailsList, setPlanDetailsList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [moreModal, setMoreModal] = useState(false);
  const [selectedItemDetails, setSelectedItemDetails] = useState(null);
  const { cartData } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const CURRENCYCODE = process.env.REACT_APP_CURRENCYCODE || "";

  const getServiceDetails = async (code) => {
    const response = await MemberShipService.getMembershipPlans({ code: code });

    let res = response?.data?.data.filter((item) => item.code === code);
    if (res.length > 0) {
      setSelectedItemDetails(res[0]);
      setMoreModal(true);
    }
  };

  const handleCloseMoreModal = () => {
    setMoreModal(false);
    setSelectedItemDetails(null);
  };

  const handleOpenMoreModal = (plan) => {
    setMoreModal(true);
    setSelectedItemDetails(plan);
  };

  useEffect(() => {
    if (patientData && patientData.patientId) {
      getPatientMembershipDetails();
    }
  }, [patientData]);

  const getPatientMembershipDetails = async () => {
    setLoading(true);
    try {
      let payload = {
        patientId: patientData.patientId,
        // patientId: "DZP5451856",
        status: 1,
      };

      let res = await MemberShipService.getPatientMembershipDetails(payload);
      if (!res?.data?.data) {
        setPlanDetails({
          membershipCode: "FREE",
        });
      } else {
        setPlanDetails(res.data.data[0] || null);
        setPlanDetailsList(res.data.data || null);
      }
    } catch (error) {
      message.error("An Error Occured....");
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/joinmembership");
  };
  const patientMembership = () => {
    navigate("/joinmembership");
  };

  const checkMembershipStatus = async (membStatPayload) => {
    try {
      const res = await PatientService.patientMembershipStatus(membStatPayload);
      return res?.data?.data;
    } catch (e) {
      console.error(e);
    }
  };

  const [loader, setLoader] = useState(false);

  const handleRenew = async (plan) => {

    if (!patientData && !patientData?.patientId) {
      message.error("patient details not available.");
      return;
    }

    // const familyObj = {
    //   familyMember1: plan?.familyMember1,
    //   familyMember2: plan?.familyMember2,
    //   familyMember3: plan?.familyMember3,
    //   familyMember4: plan?.patientId,
    // };

    // const currSelPat = Object.values(familyObj).filter(Boolean);

    // const currSelPatientIdsPayload = currSelPat.map((id) => ({
    //   patientId: id,
    //   membershipCode: plan?.membershipCode,
    // }));

    // const selectedPatMemStatuses = await checkMembershipStatus(
    //   currSelPatientIdsPayload
    // );

    // const isThereAnyInvalid = selectedPatMemStatuses?.some(
    //   (item) => item.message === "Invalid"
    // );

    // if (isThereAnyInvalid) {
    //   const invalidPatient = selectedPatMemStatuses?.find(
    //     (item) => item.message === "Invalid"
    //   );
    //   const patientDetails = currSelPat?.find(
    //     (item) => item.patientId === invalidPatient?.patientId
    //   );

    //   message.error(
    //     `${patientDetails?.firstName + " " + patientDetails?.lastName} ${
    //       invalidPatient?.comment
    //     }`
    //   );
    //   return;
    // }
    setLoader(true);
    const existingCartId = cartData?.cartId;
    const fromDateVal = dayjs().format("YYYY-MM-DD HH:mm:ss");
    const toDateVal = dayjs().add(30, "day").format("YYYY-MM-DD HH:mm:ss");
    const totalAmount = plan.totalAmount;

    const totalMembers =
      plan?.membershipCode === "SINGLE"
        ? 1
        : plan?.membershipCode === "TWIN"
          ? 2
          : 4;

    const orderDetailTemplate = (item) => ({
      accountId: patientData?.account_Id,
      clinicId: patientData?.clinic_Id,
      orderCode: item.serviceCategory,
      orderName: item.serviceName,
      orderType: "MEMBERSHIP",
      orderState: "N",
      patientId: patientData?.patientId,
      status: 1,
      createdBy: patientData?.patientId,
      modifiedBy: patientData?.patientId,
      createdDate: getCurrentTime(),
      modifiedDate: getCurrentTime(),
      discountPercentage: item.discountPercentage,
    });

    const response = await MemberShipService.getMembershipPlans({
      code: plan?.membershipCode,
    });

    let cartOrderDtl = response?.data?.data.filter(
      (item) => item.code === plan?.membershipCode,
    );


    let payload;
    const orderHeader = {
      accountId: patientData?.account_Id,
      amount: totalAmount,
      cartOrderDtl:
        cartOrderDtl[0]?.membershipServiceDetailsList.map(orderDetailTemplate),
      clinicId: patientData?.clinic_Id,
      deliveryAddress1: patientData?.address1 || "",
      deliveryCity: patientData?.city,
      deliveryCountry: patientData?.country,
      deliveryState: patientData?.state,
      deliveryZipCode: patientData?.pinCode,
      discountAmount: 0,
      discountPercentage: 0,
      orderType: "MEMBERSHIP",
      paidAmount: totalAmount,
      patientId: patientData?.patientId,
      status: 1,
      createdDate: getCurrentTime(),
      modifiedDate: getCurrentTime(),
      membershipCode: plan?.membershipCode,
      membershipName: plan?.membershipName,
      fromDate: fromDateVal,
      toDate: toDateVal,
      total_members: totalMembers,
      renewalStatus: "RENEWAL",
    };

    if (plan.membershipCode === "TWIN") {
      orderHeader.familyMember1 = plan?.familyMember1;
    } else if (plan.membershipCode === "FAMILY") {
      orderHeader.familyMember1 = plan?.familyMember1;
      orderHeader.familyMember2 = plan?.familyMember2;
      orderHeader.familyMember3 = plan?.familyMember3;
    }

    if (!existingCartId) {
      payload = {
        cartOrderHdr: [orderHeader],
        cartType: 1,
        patientId: patientData?.patientId,
        paymentType: "",
        status: 1,
      };
    } else {
      payload = {
        ...cartData,
        cartId: existingCartId,
        modifiedDate: getCurrentTime(),
        cartOrderHdr: [...(cartData?.cartOrderHdr || []), orderHeader],
      };
    }
    try {
      const result = await dispatch(AddtoCart(payload));
      if (result?.data) {
        const cartPayload = { patientId: patientData.patientId };
        dispatch(getCartDetails(cartPayload));
        getPatientMembershipDetails();
        setLoader(false);
        message.success("Membership Renewal added to cart successfully.");
      }
    } catch (error) {
      setLoader(false);
      console.error("Cart API error:", error);
    }
  };

  if (!patientData || loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center mt-[10%]">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>
      </Layout>
    );
  }
  return (
    <Layout>
      <div>
        <div className="w-[70%] sm:w-[90%] m-auto mt-7">
          <h1 className="bg-gradient-to-r from-[#189FAA] to-[#004B73] bg-clip-text text-transparent text-lg font-sans font-bold inline-block">
            Membership
          </h1>
          <div
            className="bg-cover bg-center mt-3 w-full border border-[#A3D4D8] rounded-lg p-5"
            style={{ backgroundImage: `url(${membercard})` }}
          >
            <div className="flex justify-between">
              {" "}
              <p className="text-[#232323] font-inter text-sm font-medium">
                Current membership details
              </p>
              <button
                onClick={handleClick}
                className="font-sans bg-primaryColor text-sm sm:text-xs font-semibold flex justify-center items-center text-white px-3 py-2 rounded-md sm:h-full h-8"
              >
                View Plans
              </button>
            </div>
            <div className="bg-[#F6FEFF] rounded-md p-4 mt-5">
              {planDetails?.membershipCode == "FREE" ? (
                <div className="flex sm:flex-col justify-between px-3">
                  <div className="flex gap-2 items-center">
                    {patientData?.photoName && (
                      <img
                        src={
                          process.env.REACT_APP_IMAGE_URL +
                          patientData?.photoName
                        }
                        alt=""
                        className="w-10 h-10 rounded-full"
                      />
                    )}
                    <div className="flex flex-col gap-1">
                      <p className="text-[#333333] font-semibold font-inter text-sm">
                        {`${patientData?.salutation || ""} ${
                          patientData?.firstName || ""
                        } ${patientData?.lastName || ""}`}
                      </p>
                      <p className="text-[#232323] text-xs font-inter font-medium">
                        {patientData?.patientId}
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-2 items-center">
                    <div className=" border border-[#E3D2A8] rounded-full w-7 h-7 flex items-center justify-center">
                      <img src={member} alt="" className="w-5 h-5" />
                    </div>
                    <div className="flex flex-col gap-1">
                      <p className="text-[#333333] font-semibold font-inter text-sm">
                        Current membership
                      </p>
                      <p className="text-[#1F67D3] text-xs font-inter font-medium">
                        {planDetails?.membershipCode || ""}
                      </p>
                    </div>
                  </div>
                  {planDetails?.membershipCode == "FREE" && (
                    <button
                      className="text-base sm:text-xs font-sans font-semibold py-1 bg-gradient-to-r from-[#11B0BD] to-[#2187BC] w-40 sm:w-full rounded-lg text-white"
                      onClick={handleClick}
                    >
                      Join membership
                    </button>
                  )}
                </div>
              ) : (
                <div className="relative">
                  <div className="flex gap-3 items-center">
                    <p className="text-xs font-sans font-semibold text-gray-700 flex gap-1">
                      Purchased Date:
                      <span className="text-black font-sans font-semibold text-xs">
                        {dayjs(planDetails?.fromDate).format("DD/MM/YYYY")}{" "}
                      </span>
                    </p>
                  </div>
                  <div className="bg-[#FF962C] -top-2 inline-block right-0 absolute px-2 rounded-tl-lg justify-end items-end">
                    <span className="text-xs text-white font-sans font-semibold">
                      Renewal date:
                      <span>
                        {" "}
                        {dayjs(planDetails?.toDate).format("DD/MM/YYYY")}
                      </span>
                    </span>
                  </div>
                  <div className="bg-[#F6FEFF] rounded-md p-4 border-[#4CD7E2] border-2">
                    <div className="flex justify-between items-center">
                      <div className="border-2 rounded-md border-[#81CAF4] w-40 text-center p-1 bg-white shadow-md mx-3">
                        <h3 className="text-sm font-sans font-bold flex gap-2 items-center text-[#4A99A0]">
                          {planDetails?.status == 1 && (
                            <img src={Tickicon} alt="Active" />
                          )}
                          {planDetails?.membershipCode == "SINGLE" ? (
                            <img src={single} alt="" />
                          ) : planDetails?.membershipCode == "TWIN" ? (
                            <img src={twin} alt="" />
                          ) : planDetails?.membershipCode == "FAMILY" ? (
                            <img src={family} alt="" />
                          ) : (
                            ""
                          )}

                          {planDetails?.membershipCode}
                        </h3>
                        <p className="text-xs font-sans text-gray-500">
                          Membership
                        </p>
                      </div>
                      <p className="text-xs font-sans font-semibold text-gray-700 flex gap-2 items-center">
                        Policy Validity till:
                        <span className="text-black font-sans font-semibold text-xs">
                          {`${dayjs(planDetails?.fromDate).format(
                            "DD/MM/YYYY",
                          )} - ${dayjs(planDetails?.toDate).format(
                            "DD/MM/YYYY",
                          )}`}
                        </span>
                        <span className="bg-[#1DB94C] text-white font-sans font-semibold rounded-md px-2 py-1">
                          {planDetails?.status == 1
                            ? "Active"
                            : planDetails?.status == 0
                              ? "In-Active"
                              : planDetails?.status == 2
                                ? "Renewed"
                                : "Expired"}
                        </span>
                      </p>
                      {planDetails?.renewalStatus == "RENEWAL" && (
                        <button
                          onClick={() => handleRenew(planDetails)}
                          className="font-sans bg-primaryColor text-sm font-semibold flex justify-center items-center text-white px-3 py-2 rounded-md h-8"
                        >
                          Renew
                        </button>
                      )}
                    </div>
                    <div className="flex justify-between px-3 mt-4">
                      <div className="flex gap-2">
                        <div className="flex gap-2 items-center">
                          {patientData?.photoName && (
                            <img
                              src={
                                process.env.REACT_APP_IMAGE_URL +
                                patientData?.photoName
                              }
                              alt=""
                              className="w-10 h-10 rounded-full"
                            />
                          )}
                          <div className="flex flex-col gap-1">
                            <p className="text-[#333333] font-semibold font-sans text-sm">
                              {planDetails?.patientName}
                            </p>
                            <p className="text-[#232323] text-xs font-sans font-medium">
                              {planDetails?.patientId}
                            </p>
                          </div>
                        </div>
                        {planDetails?.familyMemberList.map((member, index) => (
                          <div key={index} className="flex gap-2 items-center">
                            {member?.familyMemberPhoto && (
                              <img
                                src={
                                  process.env.REACT_APP_IMAGE_URL +
                                  member?.familyMemberPhoto
                                }
                                alt=""
                                className="w-10 h-10 rounded-full"
                              />
                            )}
                            <div className="flex flex-col gap-1">
                              <p className="text-[#333333] font-semibold font-sans text-sm">
                                {member?.familyMemberName}
                              </p>
                              <p className="text-[#232323] text-xs font-sans font-medium">
                                {member?.familyMemberId}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="flex gap-2 items-center">
                        <div className=" border bg-[#D4F1F0] rounded-full w-7 h-7 flex items-center justify-center">
                          <LiaRupeeSignSolid className="text-primaryColor" />
                        </div>
                        <div className="flex flex-col gap-1">
                          <p className="text-gray-500 font-semibold font-inter text-xs">
                            Membership Paid -
                            <span className="font-sans font-bold text-black">
                              {`${CURRENCYCODE} ${planDetails?.totalAmount}`}
                            </span>
                          </p>
                          <p className="text-gray-400 text-xs font-sans font-semibold flex gap-1">
                            {`(${dayjs(planDetails?.fromDate).format(
                              "DD/MM/YYYY",
                            )})`}
                            {/* <span className="text-[#1F67D3] underline font-semibold cursor-pointer">
                              Download Receipt
                            </span> */}
                          </p>
                        </div>
                      </div>
                      <div className="flex gap-2 items-center">
                        <div className=" border bg-[#D4F1F0] rounded-full w-7 h-7 flex items-center justify-center">
                          <CiMedicalCase className="text-primaryColor" />
                        </div>
                        <p
                          onClick={() =>
                            getServiceDetails(planDetails?.membershipCode)
                          }
                          className="text-[#232323] text-xs underline font-semibold cursor-pointer"
                        >
                          Services Details
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="mt-5 border border-[#AFAFAF] rounded-lg mb-10">
            <p className="text-[#232323] font-inter font-medium text-sm mt-3 px-5">
              Purchase Records
            </p>
            <hr className="mt-3" />
            {planDetailsList && planDetailsList.length > 0 ? (
              <>
                {planDetailsList.map((item, index) => (
                  <div className=" rounded-md p-2 m-4 border-2">
                    <div className="flex justify-between items-center">
                      <div className="border-2 rounded-md border-[#81CAF4] w-40 text-center p-1 bg-white shadow-md mx-3">
                        <h3 className="text-sm font-sans font-bold flex gap-2 items-center text-[#4A99A0]">
                          {item?.status == 1 && (
                            <img src={Tickicon} alt="Active" />
                          )}
                          {item?.membershipCode == "SINGLE" ? (
                            <img src={single} alt="" />
                          ) : item?.membershipCode == "TWIN" ? (
                            <img src={twin} alt="" />
                          ) : item?.membershipCode == "FAMILY" ? (
                            <img src={family} alt="" />
                          ) : (
                            ""
                          )}

                          {item?.membershipCode}
                        </h3>
                        <p className="text-xs font-sans text-gray-500">
                          Membership
                        </p>
                      </div>
                      <p className="text-xs font-sans font-semibold text-gray-700 flex gap-2 items-center">
                        Membership Period:
                        <span className="text-black font-sans font-semibold text-xs">
                          {`${dayjs(item?.fromDate).format(
                            "DD/MM/YYYY",
                          )} - ${dayjs(item?.toDate).format("DD/MM/YYYY")}`}
                        </span>
                        <span className="bg-[#1DB94C] text-white font-sans font-semibold rounded-md px-2 py-1">
                          {item?.status == 1
                            ? "Active"
                            : item?.status == 0
                              ? "In-Active"
                              : item?.status == 2
                                ? "Renewed"
                                : "Expired"}
                        </span>
                      </p>

                      <p className="text-xs font-sans font-semibold text-gray-700 flex gap-2 items-center">
                        Purchased Date:
                        <span className="text-black font-sans font-semibold text-xs">
                          {`${dayjs(item?.fromDate).format(
                            "DD/MM/YYYY",
                          )} - ${dayjs(item?.toDate).format("DD/MM/YYYY")}`}
                        </span>
                      </p>
                      <div></div>
                    </div>
                    <div className="flex gap-2 mt-2 mx-4">
                      <div className="flex gap-2">
                        <div className=" border bg-[#D4F1F0] rounded-full w-7 h-7 flex items-center justify-center">
                          <LiaRupeeSignSolid className="text-primaryColor" />
                        </div>
                        <div className="flex flex-col gap-1">
                          <p className="text-gray-500 font-semibold font-inter text-xs">
                            Membership Paid -
                            <span className="font-sans font-bold text-black">
                              {`${CURRENCYCODE} ${item?.totalAmount}`}
                            </span>
                          </p>
                          <p className="text-gray-400 text-xs font-sans font-semibold flex gap-1">
                            {`(${dayjs(item?.fromDate).format("DD/MM/YYYY")})`}
                          </p>
                        </div>
                      </div>
                      |
                      <div className="flex gap-2">
                        <div className=" border bg-[#D4F1F0] rounded-full w-7 h-7 flex items-center justify-center">
                          <CiMedicalCase className="text-primaryColor" />
                        </div>
                        <p
                          onClick={() =>
                            getServiceDetails(item?.membershipCode)
                          }
                          className="text-[#232323] text-xs underline font-semibold cursor-pointer"
                        >
                          Services Details
                        </p>
                      </div>
                    </div>

                    <div className="flex justify-between px-3 mt-4">
                      <div className="flex gap-2">
                        <div className="flex gap-2 items-center">
                          {patientData?.photoName && (
                            <img
                              src={
                                process.env.REACT_APP_IMAGE_URL +
                                patientData?.photoName
                              }
                              alt=""
                              className="w-10 h-10 rounded-full"
                            />
                          )}
                          <div className="flex flex-col gap-1">
                            <p className="text-[#333333] font-semibold font-sans text-sm">
                              {item?.patientName}
                            </p>
                            <p className="text-[#232323] text-xs font-sans font-medium">
                              {item?.patientId}
                            </p>
                          </div>
                        </div>
                        {item?.familyMemberList.map((member, index) => (
                          <div key={index} className="flex gap-2 items-center">
                            {member?.familyMemberPhoto && (
                              <img
                                src={
                                  process.env.REACT_APP_IMAGE_URL +
                                  member?.familyMemberPhoto
                                }
                                alt="User"
                                className="w-8 h-8 rounded-full"
                              />
                            )}
                            <div className="flex flex-col gap-1">
                              <p className="text-[#333333] font-semibold font-sans text-sm">
                                {member?.familyMemberName}
                              </p>
                              <p className="text-[#232323] text-xs font-sans font-medium">
                                {member?.familyMemberId}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <>
                <div className="flex justify-center items-center">
                  <img src={Empty} alt="" />
                </div>
                <div className="flex flex-col gap-2 justify-center items-center text-center">
                  <p className="font-inter font-semibold text-base">
                    The list is Empty
                  </p>
                  <p className="text-[#595959] text-xs font-inter font-medium">
                    Get instant discounts on doctor appointments, medicines,
                    <br /> and lab tests. Take the next step in affordable,
                    <br /> convenient care -become a member now!
                  </p>
                  <button
                    className="mt-2 text-sm  sm:text-xs mb-14 font-inter bg-gradient-to-r from-[#11B0BD] to-[#2187BC] w-80 sm:w-full py-2 rounded-lg text-white"
                    onClick={patientMembership}
                  >
                    Join membership, start saving
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Modal
        open={moreModal}
        onCancel={handleCloseMoreModal}
        destroyOnClose
        footer={[]}
        title={selectedItemDetails?.description}
      >
        <div>
          <div className="mt-4 pt-3 border-t bg-gray-50 text-gray-400 p-2 -mx-4 -mb-4 rounded-b-xl text-sm">
            <span className="text-[#6FC2F2] font-semibold">
              {selectedItemDetails?.upto_Discount_Percent}
            </span>{" "}
          </div>
          <ul className="mt-4">
            {selectedItemDetails?.membershipServiceDetailsList?.map(
              (plan, idx) => (
                <li className="flex items-center py-0.5" key={idx}>
                  <svg
                    className="w-4 h-4 mr-2 text-[#34CF47] flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold mx-1">
                    {plan?.discountPercentage} Discount
                  </span>
                  <span className="text-gray-400">{plan?.serviceName}</span>
                </li>
              ),
            )}
          </ul>
        </div>
      </Modal>
    </Layout>
  );
}

export default Membership;
